import { BnumConfig } from 'core/utils/BnumConfig';

export const ID_ACTIONS_CONTAINER = 'input-search-actions-container';
export const ID_CLEAR_BUTTON = 'input-clear-button';
export const SLOT_ACTIONS = 'actions';
export const EVENT_SEARCH = 'bnum-input-search:search';
export const EVENT_BUTTON_CLICK = 'bnum-input:button.click';
export const EVENT_CLEAR = 'bnum-input-search:clear';
export const TEXT_SEARCH_FIELD =
  BnumConfig.Get('local_keys')?.search_field || 'Rechercher';
export const BUTTON_ICON = 'search';
export const INPUT_TYPE = 'search';
